import { Component, Input, ViewChild } from '@angular/core';
import { CommonModule } from '@angular/common';
import { MatIconModule } from '@angular/material/icon';
import { SharedModule } from 'src/app/shared/shared.module';
import { ButtonModule } from 'src/app/common/button/button.module';
import { UtilService, VariablesService } from 'src/app/shared/services';
import { NgxGlideModule } from 'ngx-glide';
import { Router } from '@angular/router';
import { PRICE_BREAKUP_INFO } from '../hf-price-breakup/price-breakup-info';
import { CloseBtnModule } from 'src/app/common/close-btn/close-btn.module';

@Component({
  selector: 'app-hf-plan-details',
  standalone: true,
  imports: [
    CommonModule,
    MatIconModule,
    SharedModule,
    ButtonModule,
    NgxGlideModule,
    CloseBtnModule
  ],
  templateUrl: './hf-plan-details.component.html',
  styleUrls: ['./hf-plan-details.component.scss']
})
export class HfPlanDetailsComponent {
  @Input() plans;
  @Input() amountData;
  @Input() recommended;
  @ViewChild('dialogRef') dialogRef;
  userData;

  constructor(
    public util: UtilService,
    private router: Router,
    private vars: VariablesService
  ) {}

  priceBreakupInfo = PRICE_BREAKUP_INFO;
  screenWidth = 0;

  ngOnInit() {
    this.vars.userData.subscribe({
      next: user => {
        if (user) {
          this.userData = user;
        }
      }
    });
    if (typeof window !== 'undefined') {
      this.screenWidth = window.innerWidth;
    }
  }

  onPlanBuy(type) {
    if (this.userData) {
      this.router.navigate(['/healthfirst/price-breakup'], {queryParams: {plan: type}})
    } else {
      this.util.router.navigate(['/new/signin'], { queryParams: { redirect_uri: '/healthfirst/price-breakup', vendor: 'medibuddy', plan: type, logintype: 'homepage' }, queryParamsHandling: 'merge' });
    }
  }

}
